var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fff"},[_c('img',{attrs:{"src":require("@/assets/img/oks.png"),"alt":""}}),_vm._v(" "),_c('div',{attrs:{"id":"ok"}},[_vm._v(_vm._s(_vm.$t('ok.title')))]),_vm._v(" "),_c('div',{staticClass:"loginButton",on:{"click":_vm.gonew}},[_vm._v(_vm._s(_vm.$t('ok.ok')))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fd1cbaba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ok.vue
// module id = null
// module chunks = 